/* eslint-disable no-restricted-globals */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { bindActionCreators } from 'redux';
import * as carsActions from '../../redux/actions/cars';
import * as optionsActions from '../../redux/actions/options';
import { selectorCars, selectorFetching } from '../../redux/selectors/cars';
import { selectorWebsite, selectorDealer } from '../../redux/selectors/options';
import styles from './Controls.scss';

const Controls = (props) => {
  const {
    controlWebsiteId,
    controlVIN,
    controlCondition,
    controlPageTemplate,
  } = props;

  const [displayControlCondition, setDisplayControlCondition] =
    useState(controlCondition);
  const [displayControlWebsiteId, setDisplayControlWebsiteId] =
    useState(controlWebsiteId);
  const [displayControlVIN, setDisplayControlVIN] = useState(controlVIN);
  const [displayPageTemplate, setDisplayPageTemplate] =
    useState(controlPageTemplate);

  const clearLocalStorage = () => {
    window.localStorage.removeItem('prodigy:dealIdSetDate');
    window.localStorage.removeItem('prodigy:dealId');
    location.reload();
  };

  useEffect(() => {
    setDisplayControlCondition(controlCondition);
  }, [controlCondition]);

  useEffect(() => {
    setDisplayControlWebsiteId(controlWebsiteId);
  }, [controlWebsiteId]);

  useEffect(() => {
    setDisplayControlVIN(controlVIN);
  }, [controlVIN]);

  useEffect(() => {
    setDisplayPageTemplate(controlPageTemplate);
  }, [controlPageTemplate]);

  const conditionIsDisabled = () => {
    return displayControlVIN || !displayControlWebsiteId;
  };

  const changePageTemplate = (pageTemplate) => {
    setDisplayPageTemplate(pageTemplate);
  };

  const changeDisplayCondition = (condition) => {
    if (!conditionIsDisabled()) {
      setDisplayControlCondition(condition);
    }
  };

  return (
    <div className={styles.controlPanelContainer}>
      <form className={styles.controlPanelForm}>
        <div className={styles.inputGroup}>
          <label htmlFor="srp" onClick={() => changePageTemplate('SRP')}>
            <input
              type="radio"
              id="srp"
              name="pageTemplate"
              value="SRP"
              checked={displayPageTemplate === 'SRP'}
              onChange={() => changePageTemplate('SRP')}
            />
            SRP
          </label>
          <label htmlFor="vdp" onClick={() => changePageTemplate('VDP')}>
            <input
              type="radio"
              id="vdp"
              name="pageTemplate"
              value="VDP"
              checked={displayPageTemplate === 'VDP'}
              onChange={() => changePageTemplate('VDP')}
            />
            VDP
          </label>
          <label
            htmlFor="standalone"
            onClick={() => changePageTemplate('standalone')}
          >
            <input
              type="radio"
              id="standalone"
              name="pageTemplate"
              value="standalone"
              checked={displayPageTemplate === 'standalone'}
              onChange={() => changePageTemplate('standalone')}
            />
            Standalone
          </label>
        </div>
        <div className={styles.inputGroup}>
          <label htmlFor="websiteId">
            WebsiteId
            <input
              type="text"
              name="websiteId"
              id="websiteId"
              placeholder="websiteId"
              value={displayControlWebsiteId || ''}
              onChange={(e) => setDisplayControlWebsiteId(e.target.value)}
            />
          </label>
        </div>
        <div className={styles.inputGroup}>
          <label htmlFor="vin">
            VIN
            <input
              type="text"
              name="vin"
              id="vin"
              placeholder="VIN"
              value={displayControlVIN || ''}
              disabled={!displayControlWebsiteId}
              onChange={(e) => setDisplayControlVIN(e.target.value)}
            />
          </label>
        </div>
        <div className={styles.inputGroup}>
          <label htmlFor="all" onClick={() => changeDisplayCondition('all')}>
            <input
              type="radio"
              id="all"
              name="condition"
              value="all"
              checked={
                !displayControlCondition || displayControlCondition === 'all'
              }
              disabled={conditionIsDisabled()}
            />
            All Vehicles
          </label>
          <label htmlFor="New" onClick={() => changeDisplayCondition('New')}>
            <input
              type="radio"
              id="New"
              name="condition"
              value="New"
              checked={displayControlCondition === 'New'}
              disabled={conditionIsDisabled()}
            />
            New
          </label>
          <label htmlFor="Used" onClick={() => changeDisplayCondition('Used')}>
            <input
              type="radio"
              id="Used"
              name="condition"
              value="Used"
              checked={displayControlCondition === 'Used'}
              disabled={conditionIsDisabled()}
            />
            Used
          </label>
          <label htmlFor="CPO" onClick={() => changeDisplayCondition('CPO')}>
            <input
              type="radio"
              id="CPO"
              name="condition"
              value="CPO"
              checked={displayControlCondition === 'CPO'}
              disabled={conditionIsDisabled()}
            />
            CPO
          </label>
        </div>
        <div className={styles.inputGroup}>
          <input
            type="submit"
            value="Load Data"
            disabled={!displayControlWebsiteId}
          />
          <span>&nbsp;</span>
          <input type="button" value="Clear PII" onClick={clearLocalStorage} />
        </div>
      </form>
    </div>
  );
};

Controls.propTypes = {
  cars: PropTypes.array,
  controlWebsiteId: PropTypes.string,
  controlCondition: PropTypes.string,
  controlVIN: PropTypes.string,
  controlPageTemplate: PropTypes.string,
};

const mapStateToProps = createSelector(
  [selectorCars, selectorWebsite, selectorDealer, selectorFetching],
  (cars, website, dealer, fetching) => ({
    cars,
    website,
    dealer,
    fetching,
  }),
);

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({ ...carsActions, ...optionsActions }, dispatch),
});

// export default (mapStateToProps, mapDispatchToProps)(Controls);
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Controls),
);
